<template>
  <div class="container">
    <custom-select
      label="Actividad"
      :value="value"
      name="actividad"
      @input="onChange"
      :items="actividades"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import { actividades as _actividades } from "@/config/constants";
import CustomSelect from "@/components/core/custom/CustomSelect";
import find from "lodash/find";
import get from "lodash/get";

export default {
  name: "WorkActivity",
  components: { CustomSelect },
  props: {
    value: String,
    situacionLaboral: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actividades: []
    };
  },
  watch: {
    situacionLaboral: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getActividades(newVal);
      }
    }
  },
  mounted() {
    if (this.situacionLaboral) {
      this.getActividades(this.situacionLaboral);
    }
  },
  methods: {
    getActividades(situacionLaboral) {
      this.actividades = [];
      // Tengo que filtrarlas por Situacion situacionLaboral
      _actividades.forEach(val => {
        if (val.situacionLaboral.indexOf(situacionLaboral) >= 0) {
          this.actividades.push(val);
        }
      });
      let defaultValue = get(
        find(this.actividades, { value: this.value }),
        "value",
        this.actividades[0].value
      );
      this.$emit("input", defaultValue);
    },
    onChange(val) {
      this.$emit("input", val);
    }
  }
};
</script>
